import { defineField, Validators } from '@/form/useForm'
import type { UseAssetFormState, UseAssetFormComputedData } from '../types'
import {
  AVAILABLE_ALTERNATIVE_SUBTYPES,
  AVAILABLE_LISTED_EQUITY_SUBTYPES,
  AVAILABLE_REAL_ESTATE_SUBTYPES,
  AVAILABLE_UNLISTED_EQUITY_SUBTYPES,
  AVAILABLE_CASH_SUBTYPES,
  EAssetAutomationLevel,
  EAssetSubtype,
  EAssetType,
  evaluateAssetAutomationLevel
} from 'findef'
import { lockedByProvider } from '../toolips'

export const subtypesField = () => {
  return defineField<UseAssetFormState, any, UseAssetFormComputedData>({
    label: 'Type',
    validators: [Validators.required()],
    required: true,
    type: 'string',
    value: EAssetSubtype.STOCK,
    transformType: 'array',
    component: 'select-dropdown',
    needs: [
      'asset.type',
      'asset.listed',
      'asset.companyProfile',
      'asset.commodityQuote',
      'asset.cryptoQuote',
      'asset.automation'
    ],
    next: (state) => {
      return {
        label: state.asset.type === EAssetType.EQUITY
          ? 'Type of Equity'
          : state.asset.type === EAssetType.CASH
            ? 'Type of Account'
            : 'Type',
        value: (state.asset.listed && state.asset.companyProfile)
          ? [
              state.asset.companyProfile.isEtf
                ? EAssetSubtype.ETF
                : state.asset.companyProfile.isFund
                  ? EAssetSubtype.FUND
                  : EAssetSubtype.STOCK
            ]
          : state.asset.subtypes || [],

        locked:
          state.asset.type === EAssetType.ALTERNATIVE
            ? false
            : (evaluateAssetAutomationLevel(state.asset) === EAssetAutomationLevel.SEMI_AUTOMATIC ||
              !!state.providerImport ||
              !!state.asset.provider),
        ...(!!state.providerImport || !!state.asset.provider
          ? {
              ...lockedByProvider(state)
            }
          : {}),
        options: {
          search: { enabled: false },
          items: (state.asset.type === EAssetType.ALTERNATIVE
            ? AVAILABLE_ALTERNATIVE_SUBTYPES
            : state.asset.type === EAssetType.CASH
              ? AVAILABLE_CASH_SUBTYPES
              : state.asset.type === EAssetType.REAL_ESTATE
                ? AVAILABLE_REAL_ESTATE_SUBTYPES
                : state.asset.listed
                  ? AVAILABLE_LISTED_EQUITY_SUBTYPES
                  : AVAILABLE_UNLISTED_EQUITY_SUBTYPES
          ).map((it) => ({ ...it, key: it.value }))
        }
      }
    }
  })
}
